function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, dateInputFocused, description, invalidDescription, saving, tmpDate) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'create-annotation-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'create-annotation-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'create-annotation-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Add Annotation");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'create-annotation-date-input-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'create-annotation-date-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": __vjadeStringifyAttrsIfObj({
                open: dateInputFocused,
                'selected-option': $helpers.getFormattedTime(`MMM D, YYYY`),
              }),
              "on": {
                menuChange: $helpers.handleDateSelectChange,
              },
              "class": {
                'create-annotation-date-select': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'slot': `body`
                }),
                "class": {
                  'create-annotation-date-popup-content': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-calendar", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'selected-date': $helpers.getFormattedTime(`YYYY-MM-DD`, tmpDate)
                  }),
                  "on": {
                    selectDate: $helpers.handleDateSelected
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'slot': `footer`
                }),
                "class": {
                  'create-annotation-date-popup-footer': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'slot': `footer`
                  }),
                  "on": {
                    click: $helpers.handleSelectDateButtonClicked
                  },
                  "class": {
                    'mp-button-bar-primary': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Select date");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'create-annotation-at-label': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("at");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'create-annotation-time-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'disable-search': true,
                sections: JSON.stringify([{
                  items: $helpers.getTimeItems()
                }]),
                'selected-option': $helpers.getFormattedTime(`hh:mma`),
              }),
              "on": {
                change: $helpers.handleTimeSelectChange,
              },
              "class": {
                'create-annotation-time-select': true
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'create-annotation-description': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("textarea", {
            "attrs": __vjadeStringifyAttrsIfObj({
              placeholder: `Add a description`
            }),
            "on": {
              input: $helpers.updateDescription
            },
            "hook": {
              insert: $helpers.descriptionTextareaInserted
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(description);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((invalidDescription) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'always-show': true,
                placement: `bottom`,
                type: `error`,
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Please enter a description");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'create-annotation-actions-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              theme: `tertiary`
            }),
            "on": {
              click: $helpers.cancelCreation
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Cancel");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              theme: `primary`,
              disabled: saving
            }),
            "on": {
              click: $helpers.saveAnnotation
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Save");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "dateInputFocused" in locals ? locals.dateInputFocused : typeof dateInputFocused !== "undefined" ? dateInputFocused : undefined, "description" in locals ? locals.description : typeof description !== "undefined" ? description : undefined, "invalidDescription" in locals ? locals.invalidDescription : typeof invalidDescription !== "undefined" ? invalidDescription : undefined, "saving" in locals ? locals.saving : typeof saving !== "undefined" ? saving : undefined, "tmpDate" in locals ? locals.tmpDate : typeof tmpDate !== "undefined" ? tmpDate : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;